import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";

import { LinkButton } from "./ui";

export function Hero() {
  function scrollForDetails() {
    window.scrollBy({
      top: window.innerHeight * 0.4,
      behavior: "smooth",
    });
  }

  return (
    <section className="relative flex min-h-screen items-center overflow-hidden pb-28 pt-16">
      <div className="absolute inset-0 z-0">
        <img
          src="/BADTOUCH6.jpg"
          alt="Sim racing broadcast car"
          className="h-full w-full object-cover opacity-35"
        />
        <div className="absolute inset-0 bg-bg/70" />
        <div className="absolute inset-0 bg-gt-grid opacity-40" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,var(--bg)_100%)]" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-48 bg-gradient-to-b from-transparent to-bg" />
      </div>

      <div className="absolute left-6 top-24 z-10 flex flex-col gap-1 font-mono text-[10px] tracking-[0.3em] text-muted md:left-12" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="mb-6 flex items-center gap-3"
          >
            <div className="h-px w-10 bg-primary" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-primary">
              Overlay Control · For iRacing
            </span>
          </motion.div>

          <motion.h1
            className="mb-8 font-display text-6xl font-bold uppercase leading-[0.88] tracking-[-0.02em] text-text md:text-8xl lg:text-[9rem]"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
          >
            BROADCAST.
            <br />
            OVERLAY.
            <br />
            <span className="text-transparent [-webkit-text-stroke:2px_var(--primary)]">WIN.</span>
          </motion.h1>

          <motion.p
            className="mb-10 max-w-xl text-lg leading-relaxed text-muted md:text-xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
          >
            The professional suite of apps for iRacing broadcasters and streamers.
          </motion.p>

          <motion.div
            className="flex flex-col gap-3 sm:flex-row"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
          >
            <LinkButton href="/download" size="lg">
              START BROADCASTING <ArrowRight size={16} />
            </LinkButton>
            <LinkButton href="/docs/" variant="ghost" size="lg">
              <BookOpen size={14} /> VIEW DOCS
            </LinkButton>
          </motion.div>
        </div>
      </div>

      <motion.div
        className="absolute bottom-6 left-0 right-0 z-10 mx-auto max-w-7xl px-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.6 }}
      >
        <div className="flex items-center justify-between border-t border-border pt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-muted">
          <button
            type="button"
            onClick={scrollForDetails}
            className="transition-colors hover:text-primary focus:outline-none focus-visible:text-primary"
          >
            ↓ SCROLL FOR DETAILS
          </button>
          <span className="hidden md:inline">OBS · STREAMLABS · VMIX COMPATIBLE</span>
        </div>
      </motion.div>
    </section>
  );
}
